import { push, ref, update } from 'firebase/database';
import { db } from '../firebase';

export const addConsumption = async (id: string, name: string, amount: number, currentScore: number) => {
  if (id === 'new') {
    return push(ref(db, 'consumptions/'), { name: name.toLowerCase(), score: amount });
  } else {
    const newScore = currentScore + amount;
    return update(ref(db, `consumptions/${id}`), { score: newScore });
  }
};
